export default __webpack_public_path__ + "media/images/front/policy/hero_sm-12e64d3a9a74c3588c9d5fbff2573d04.jpg";